import base64 from 'base64-encode-file';

export default class NewAsset3DController{
    
}